export default "__VITE_ASSET__CHpGBEvY__"